import {
  mediaQueries,
  spacingCalculator,
} from '@digando/react-component-library';
import React, { FC } from 'react';
import styled from '@emotion/styled';

interface IErrorMessageProps {
  children?: React.ReactNode;
}

export const TextOnlyErrorMessage: FC<IErrorMessageProps> = ({ children }) => {
  return (
    <ErrorMessageContainer>
      <TextMsg>
        <p>{children}</p>
      </TextMsg>
    </ErrorMessageContainer>
  );
};

const TextMsg = styled.div`
  display: flex;

  p {
    margin-top: auto;
    margin-bottom: auto;
    color: var(--color-error);
  }
`;

export const ErrorMessageContainer = styled.div`
  grid-column: 1 / span 12;
  margin-bottom: ${spacingCalculator(2)};

  @media ${mediaQueries.laptopL} {
    grid-column: 2 / span 10;
  }

  @media print {
    grid-column: 1 / span 12;
  }
`;
